import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import type { ServiceGroup } from '../../data/services';
type ServiceDirectoryCardProps = {
  group: ServiceGroup;
  variant: 'lead' | 'care';
};
export function ServiceDirectoryCard({
  group,
  variant
}: ServiceDirectoryCardProps) {
  const lead = variant === 'lead';
  const href = group.pageHref ?? '/services';
  const cta = group.ctas?.[0];
  const titleId = `directory-${group.id}-title`;
  return <article aria-labelledby={titleId} className={`flex h-full w-full min-w-0 flex-col ${lead ? '' : 'bg-ivory'}`} data-id="element-262" data-mp="11zd7u93025yg">
      {group.image ? <a href={href} tabIndex={-1} aria-hidden="true" className="group relative block overflow-hidden bg-stone" data-id="element-263" data-mp="1bux2yt9qp0m5">
          <div className={`relative w-full ${lead ? 'aspect-[4/3] lg:aspect-[3/2]' : 'aspect-[16/9]'}`} data-id="element-264" data-mp="1fy34xoptk5mt">
            <img src={group.image} alt="" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" data-id="element-265" data-mp="2n9k3kk0j1qpx" />
          </div>
        </a> : null}

      <div className={`flex flex-1 flex-col ${lead ? 'pt-6' : 'p-6 lg:p-8'}`} data-id="element-266" data-mp="1lyin5fiv63lu">
        <h3 id={titleId} className={`font-display font-medium leading-[1.1] text-charcoal ${lead ? 'text-[30px] lg:text-[36px]' : 'text-[28px] lg:text-[32px]'}`} data-id="element-267" data-mp="1gxbele8wd0e4">
          <a href={href} className="focus-ring transition-colors duration-150 hover:text-olive" data-id="element-268" data-mp="17yzpxhrlccob">
            {group.title}
          </a>
        </h3>
        <p className="mt-3 max-w-[580px] text-[16px] leading-relaxed text-charcoal/70" data-id="element-269" data-mp="135epzk6ft8mh">{group.summary}</p>

        <div className="mt-6 grid gap-6 border-t border-olive/20 pt-5 sm:grid-cols-2" data-id="element-270" data-mp="t9206xe0jex0">
          {group.clusters.map(cluster => <div key={cluster.title} data-id="element-271" data-mp="p6f24eqr0xrd">
              <h4 className="text-[13px] font-semibold tracking-[0.04em] text-olive" data-id="element-272" data-mp="p9je3yaggxsl">{cluster.title}</h4>
              <ul aria-label={`${group.title} — ${cluster.title}`} className="mt-3 space-y-2" data-id="element-273" data-mp="kaghn28jjzw8">
                {cluster.items.map(item => <li key={item.label} data-id="element-274" data-mp="emldyojsq92c">
                    <span className="flex items-start gap-2.5 text-[15.5px] leading-[1.5] text-charcoal/85" data-id="element-275" data-mp="eno60zsuuhju">
                      <span className="mt-[10px] h-1 w-1 shrink-0 rounded-full bg-moss/70" aria-hidden="true" data-id="element-276" data-mp="oohrt9984o7" />
                      <span data-id="element-277" data-mp="5nhrrbpc1djm">{item.label}</span>
                    </span>
                    {item.description ? <p className="mt-0.5 pl-3.5 text-[13.5px] leading-relaxed text-charcoal/65" data-id="element-278" data-mp="ya2koglghxpa">{item.description}</p> : null}
                  </li>)}
              </ul>
              {cluster.detail ? <p className="mt-2 text-[13.5px] leading-relaxed text-charcoal/65" data-id="element-279" data-mp="ojhd43nt1iu8">{cluster.detail}</p> : null}
            </div>)}
        </div>

        {cta ? <div className="mt-auto pt-6" data-id="element-280" data-mp="1h0k05jha2wsp">
            <a href={cta.href} className="focus-ring group inline-flex min-h-[44px] items-center gap-2 border-t border-charcoal/10 pt-3 text-[15px] font-medium text-olive" data-id="element-281" data-mp="1h1lmik3qv5pq">
              <span className="border-b border-olive/35 pb-0.5 transition-colors duration-150 group-hover:border-olive" data-id="element-282" data-mp="2wrvzw3mhn8mx">{cta.label}</span>
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5" strokeWidth={1.5} aria-hidden="true" data-id="element-283" data-mp="36i7f4mbmh494" />
            </a>
          </div> : null}
      </div>
    </article>;
}